// tslint:disable-next-line
export var canUseDom = function () { return !!(typeof window !== 'undefined' && window.document && window.document.createElement); };
export var renderingEnv = 'browser';
export var isMobileFriendly = true;
export var isInSEO = false;
//# sourceMappingURL=constants.js.map